import { render, staticRenderFns } from "./add-project-svg.vue?vue&type=template&id=4e7c2e08&scoped=true"
import script from "./add-project-svg.vue?vue&type=script&lang=js"
export * from "./add-project-svg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e7c2e08",
  null
  
)

export default component.exports